import VueCookies from 'vue-cookies';
import { createApp } from "vue";
import { createPinia } from "pinia";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { createI18n } from 'vue-i18n';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import en from './locales/en.json'

import App from "./App.vue";
import router from "./router";
import axios from 'axios';
import { useChartStore } from './stores/chart';
import { useCredentialStore } from './stores/credential';
import { useGeneralStore } from './stores/general';
import { useMetricsStore } from './stores/metrics';
import { useProviderStore } from './stores/provider';
import { useSessionStore } from './stores/session';
import { bffInterceptor } from './utils/interceptors';

const app = createApp(App);
const vuetify = createVuetify({
  components,
  directives,
});

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages: {
    en: en,
  }
})

app.use(VueCookies);
app.use(pinia);
app.use(router);
app.use(vuetify);
app.use(i18n);

app.mount("#app");

export const ubiquAxios = bffInterceptor(
  axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
    timeout: 15000,
    withCredentials: true,
  }),
)

// initialize stores
const sessionStore = useSessionStore()
useChartStore()
useCredentialStore()
useGeneralStore()
useMetricsStore()
useProviderStore()
sessionStore.init()

